module.exports = require('./TrendingSlideshow');
